(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  tabs= document.querySelectorAll('.custom-tab');
  tabContents= document.querySelectorAll('.custom__tab-content');

  tabs.forEach(function(tab){
      tab.addEventListener('click',function(){

          contentId = this.dataset.contentId;
          content = document.getElementById(contentId);

          tabContents.forEach(function(content){
              content.classList.remove('active');
          });

          tabs.forEach(function(tab){
              tab.classList.remove('active');
          });

          this.classList.add('active');
          content.classList.add('active');

          if (document.querySelector('.review_slider .review-grid') && theme.loadLegacyCarousels) {
            theme.loadLegacyCarousels().then(function (loaded) {
              if (loaded && window.jQuery && window.jQuery.fn.slick) {
                window.jQuery('.review_slider .review-grid.slick-initialized').slick('setPosition');
              }
            }).catch(function () {});
          }
      });
  });

  } catch(e) { console.error(e); }
})();
})();
